import { ACTIONS, KEYS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";

export interface UserManagementReducer {
  payTypes: any;
  employeeTypes: any;
  roleList: any;
  users: any;
}

const initialState: UserManagementReducer = {
  payTypes: null,
  employeeTypes: null,
  roleList: null,
  users: null,
};

const userManagementReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.USER_MANAGEMENT.GET_PAY_TYPES:
            return{
               ...state,
               payTypes: action.payload,
            };
        case ACTIONS.USER_MANAGEMENT.GET_EMPLOYEE_TYPES:
            return{
               ...state,
               employeeTypes: action.payload,
            };
        case ACTIONS.USER_MANAGEMENT.ROLE_LIST:
            return{
               ...state,
               roleList: action.payload,
            };
        case ACTIONS.USER_MANAGEMENT.SEARCH_USERS:
            return{
               ...state,
               users: action.payload,
            };
        default:
        return state;
    }
}

export default userManagementReducer;
